import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IMandatorCount } from '@orgacard/login';

import { BetterRequestService } from '@services';

import { CoreService } from '../core/core.service';
import { EnvironmentService } from '../core/environment.service';
import { IAddressDisplay } from '../mwsp/shared/models/basic.model';
import { IStateResult, ISystemSetupModel } from './systemconfig.model';

export interface ISystemconfigResponse {
    applicationUuid: string;
    mandatorUuid: string;
    systemUuid: string;
}
@Injectable({
    providedIn: 'root',
})
export class SystemconfigService {
    private http = inject(HttpClient);
    private readonly betterRequestService = inject(BetterRequestService);
    private environmentService = inject(EnvironmentService);
    private coreService = inject(CoreService);

    mandatorCount: number;
    stateResults: IStateResult[] = [];

    public startDatabaseLoading(): Observable<boolean> {
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/import/firstFromJsonX509';
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.post<boolean>(
                    url,
                    {},
                    {
                        headers: this.environmentService.appSettings.headers,
                        observe: 'response',
                    },
                ),
            )
            .pipe(
                map((response) => true),
                catchError(this.coreService.handleError),
            );
    }

    public getLoadingState(): Observable<boolean> {
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/import/importState';
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.get<IStateResult[]>(url, {
                    headers: this.environmentService.appSettings.headers,
                    observe: 'response',
                }),
            )
            .pipe(
                map((response) => {
                    this.stateResults = response.body;
                    const ind = this.stateResults.findIndex((sr) => sr.stateMsg.indexOf('Import finished') > 0);
                    if (ind > 0) {
                        return true;
                    }
                    return false;
                }),
                catchError(this.coreService.handleError),
            );
    }

    public save(systemSetup: ISystemSetupModel): Observable<ISystemconfigResponse> {
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/usermanagement/setupsystem';
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.post<ISystemconfigResponse>(url, systemSetup, {
                    headers: this.environmentService.appSettings.headers,
                }),
            )
            .pipe(
                map((systemconfigResponse) => systemconfigResponse),
                catchError(this.coreService.handleError),
            );
    }

    getMandatorCount(): Observable<boolean> {
        let url: string = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/systemuser/countmandator';
        if (!this.environmentService.appSettings.fakeServer) {
            url = url + '?locked=false';
            url = url + '&language=' + this.environmentService.appSettings.locale;
        }

        return this.betterRequestService
            .withoutErrorHandler(
                this.http.get<IMandatorCount>(url, {
                    headers: this.environmentService.appSettings.headers,
                }),
            )
            .pipe(
                map((response) => {
                    this.mandatorCount = response.countmandator;
                    return true;
                }),
                catchError(this.coreService.handleError),
            );
    }
}
